import { BaseController } from '~/utils/base-controller';

export default class KtableWidgetController extends BaseController {
	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor($injector) {
		super($injector);
	}

	$onInit() {
		//
	}
}
